import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Card, Spinner, Form } from 'react-bootstrap';
import AuthContext from '../../context/AuthContext';
import { useNavigate, useParams } from 'react-router-dom';
import LeadsService from '../../service/LeadsService';
import barGraph from '../../assets/bar-graph.webp';

function LeadsPage() {
    const { user, isLoggedIn } = useContext(AuthContext);
    const navigate = useNavigate();
    const { adId } = useParams();

    const [leads, setLeads] = useState([]);
    const [filteredLeads, setFilteredLeads] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterType, setFilterType] = useState('all');
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;

    useEffect(() => {
        if (!isLoggedIn()) {
            navigate('/login');
            return;
        }

        const fetchLeads = async () => {
            setLoading(true);
            try {

                if (user?.token) {
                let response;
                if (adId) {
                    response = await LeadsService.getLeadsByAdertisement(adId, user.token);
                } else {
                    response = await LeadsService.getCustomerLeads(user.token);
                }
                setLeads(response || []);
                setFilteredLeads(response || []);
                }
            } catch (error) {
                console.error('Failed to fetch leads:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchLeads();
    }, [isLoggedIn, navigate, user, adId]);

    const formatTimestamp = (utcString) => {
        const date = new Date(utcString);
        return date.toLocaleString();
    };

    const filterLeads = () => {
        const now = new Date();
        let filtered = leads;

        if (filterType === 'today') {
            filtered = leads.filter(lead => {
                const leadDate = new Date(lead.timestamp);
                return leadDate.toDateString() === now.toDateString();
            });
        } else if (filterType === 'yesterday') {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            filtered = leads.filter(lead => {
                const leadDate = new Date(lead.timestamp);
                return leadDate.toDateString() === yesterday.toDateString();
            });
        } else if (filterType === 'range' && startDate && endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);
            filtered = leads.filter(lead => {
                const leadDate = new Date(lead.timestamp);
                return leadDate >= start && leadDate <= end;
            });
        }

        setFilteredLeads(filtered);
    };


    useEffect(() => {
        filterLeads();
    }, [filterType, startDate, endDate, leads]);

    return (
        <section className='global-padding lead_page min-h-400'>
            <div className='container'>
            {/* Filter UI */}
            <Row className="mb-3 mb-md-4 justify-content-between align-items-center">
                <Col xxl={6}>
                  <div className='lead_title'>
                   <h3 className="text-left mb-3 mb-xxl-0">{adId ? `#${adId}` : 'All'} Leads</h3>
                  </div>
                </Col>

                <Col xxl={3} className="mb-2 mb-xxl-0">
                    <Form.Select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
                        <option value="all">All</option>
                        <option value="today">Today</option>
                        <option value="yesterday">Yesterday</option>
                        <option value="range">Custom Date Range</option>
                    </Form.Select>
                </Col>
                {filterType === 'range' && (
                    <Col xxl={3} className='px-xxl-0'>
                        <div className="d-flex gap-2">
                            <Form.Control className='lead_range'
                                type="date"
                                value={startDate || ''}
                                onChange={(e) => setDateRange([e.target.value, endDate])}
                            />
                            <Form.Control className='lead_range'
                                type="date"
                                value={endDate || ''}
                                onChange={(e) => setDateRange([startDate, e.target.value])}
                            />
                        </div>
                    </Col>
                )}
            </Row>

            {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                    <div className="text-center">
                        <Spinner animation="border" variant="primary" className="mb-3" />
                        <p className="text-muted">Loading leads...</p>
                    </div>
                </div>
            ) : filteredLeads.length > 0 ? (
                <Row className="fade-in">
                    {filteredLeads.map((lead, index) => (
                        <Col key={index} xs={12} sm={6} md={4} lg={3} className='lead_card mb-md-4 mb-3'>
                            <Card className="h-100">
                                <Card.Body>
                                    <div className='lead_icon'>
                                    <img src={barGraph} className='img-fluid' alt='lead'/>
                                    </div>
                                    <h5 className="card-title mb-2">
                                        Lead #{index + 1}
                                    </h5>
                                    <p className="mb-2 lead_phone">
                                        <i className="fas fa-phone me-1" ></i>
                                        <strong>{lead.phone || 'N/A'}</strong>
                                    </p>
                                    {/* <p className="lead_date">
                                        {formatTimestamp(lead.timestamp)}
                                    </p> */}
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            ) : (
                <div className="text-center mt-5">
                  <h5 className="text-muted">No leads found.</h5>
                </div>
            )}
        </div>
        </section>
    );
}

export default LeadsPage;
